import Box from '@components/Box';
import ErrorIcon from '@assets/icons/request-error.svg';
import FormErrorMessage from '@components/FormErrorMessage';
import LoginForm from './LoginForm.tsx';
import WeChatInformer from '@components/WeChatInformer';
import { Button, ButtonType } from '@components/Button';
import { Grid, Row, Column } from '@components/Grid';
import { LoginFormType } from './types';
import { Text, TextSize, TextType } from '@components/Text';
import { useAuth } from '@contexts/AuthenticationContext';
import { useMutation } from 'react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LoginPage = (props: { isAdmin?: boolean }) => {
  const { isAdmin } = props;

  const [sellerEmailOrPhone, setSellerEmailOrPhone] = useState<string>('');

  const auth = useAuth();
  const { t } = useTranslation();

  const {
    error,
    isError,
    isLoading,
    isIdle,
    mutate,
    reset,
  } = useMutation({
    mutationFn: auth.login,
  });

  const handleSubmit = (form: LoginFormType) => {
    if (isAdmin) {
      setSellerEmailOrPhone(form.sellerEmailOrPhone);
      mutate({
        username: form.emailAdmin,
        password: form.password,
        sellerEmailOrPhone: form.sellerEmailOrPhone,
      });
    } else {
      mutate({ username: form.email, password: form.password });
    }
  };

  return (
    <>
      {isError && (
        <Grid>
          <Row>
            <Column phone={12}>
              <Box pb={4}>
                <Grid>
                  <Row align={"center"}>
                    <Column phone={2}>
                      <img alt={"Icon"} src={ErrorIcon} width={"100%"} />
                    </Column>
                    <Column phone={10}>
                      <Box pl={4}>
                        <Text type={TextType.H1}>
                          {t(isAdmin ? "loginPage.adminErrorTitle" : "loginPage.errorTitle")}
                        </Text>
                      </Box>
                    </Column>
                  </Row>
                </Grid>
              </Box>
            </Column>
          </Row>

          {isAdmin ? (
            <FormErrorMessage
                black
                context={{
                  email: (data: Record<string, string>) => `<b>${data.email ?? ''}</b>`,
                  phone: () => `<b>${sellerEmailOrPhone}</b>`
                }}
                error={error}
                errorPrefix="loginPage.adminErrors"
                noPt
            />
          ) : (
            <Row>
              <Column phone={12}>
                <Box pb={2}>
                  <Text type={TextType.P} size={TextSize.M}>
                    {t("loginPage.errorMessage")}
                  </Text>
                </Box>
              </Column>
            </Row>
          )}

          <Row>
            <Column phone={12}>
              <Box pt={2}>
                <Button
                  onClick={() => reset()}
                  title={t("loginPage.returnLink")}
                  type={ButtonType.LINK}
                />
              </Box>
            </Column>
          </Row>
        </Grid>
      )}

      {(isLoading || isIdle) && (
        <>
          <LoginForm
              isAdmin={isAdmin}
              onSubmit={handleSubmit}
              pending={isLoading}
          />
          <WeChatInformer
              calledFrom="login"
              informerDescription={t('loginPage.weChatInformer.description')}
              informerTitle={t('loginPage.weChatInformer.title')}
          />
        </>
      )}
    </>
  );
};

export default LoginPage;
